module.exports = __webpack_public_path__ + "img/hos.f422a3cb.png";